import { useMarketingData } from '../MarketingContext';

export default function SettingsPage() {
  const { companies } = useMarketingData();

  return (
    <div className="space-y-6">
      <div><h1 className="text-2xl font-bold text-gray-900">Settings</h1><p className="text-sm text-gray-500">Marketing portal configuration and user management</p></div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Portal Settings */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h3 className="text-sm font-bold text-gray-900 mb-3">Portal Configuration</h3>
          <div className="space-y-3">
            <div><label className="text-xs text-gray-500 block mb-1">Organization Name</label><input defaultValue="Sai Krishna Industries" className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg" /></div>
            <div><label className="text-xs text-gray-500 block mb-1">Fiscal Year Start</label><select className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg"><option>April</option><option>January</option><option>September</option></select></div>
            <div><label className="text-xs text-gray-500 block mb-1">Default Currency</label><input defaultValue="INR (₹)" className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg" disabled /></div>
            <div><label className="text-xs text-gray-500 block mb-1">Timezone</label><input defaultValue="Asia/Kolkata (IST)" className="w-full px-3 py-2 text-sm border border-gray-200 rounded-lg" disabled /></div>
          </div>
        </div>

        {/* User Roles */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h3 className="text-sm font-bold text-gray-900 mb-3">User Roles & Permissions</h3>
          <div className="space-y-2">
            {[
              { role: 'Administrator', access: 'Full access to all modules, settings, and user management' },
              { role: 'Marketing Director', access: 'All marketing modules, strategy, analytics, and approvals' },
              { role: 'Marketing Manager', access: 'Campaigns, content, SEO, research, tasks' },
              { role: 'Content Manager', access: 'Content calendar, blogs, knowledgebase' },
              { role: 'SEO Specialist', access: 'SEO center, keyword tracking, content optimization' },
              { role: 'Researcher', access: 'Market research, knowledgebase, industry standards, blogs' },
              { role: 'Viewer', access: 'Read-only access to dashboard and reports' },
            ].map(r => (
              <div key={r.role} className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
                <div className="text-sm font-medium text-gray-800">{r.role}</div>
                <div className="text-xs text-gray-500 max-w-[250px] text-right">{r.access}</div>
              </div>
            ))}
          </div>
        </div>

        {/* Companies Config */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h3 className="text-sm font-bold text-gray-900 mb-3">Configured Companies</h3>
          <div className="space-y-2">
            {companies.map(co => (
              <div key={co.id} className="flex items-center justify-between p-2 bg-gray-50 rounded-lg">
                <div className="flex items-center gap-2">
                  <span className="text-lg">{co.logo}</span>
                  <div className="text-sm font-medium text-gray-800">{co.name}</div>
                </div>
                <span className="text-xs text-gray-500">₹{(co.budget / 100000).toFixed(1)}L budget</span>
              </div>
            ))}
          </div>
        </div>

        {/* Status Definitions */}
        <div className="bg-white border border-gray-200 rounded-xl p-5">
          <h3 className="text-sm font-bold text-gray-900 mb-3">Status Definitions</h3>
          <div className="space-y-1.5">
            {[
              { status: 'Not Started', color: 'bg-gray-200', desc: 'Work has not begun' },
              { status: 'Planning', color: 'bg-amber-200', desc: 'Being planned and scoped' },
              { status: 'In Progress', color: 'bg-blue-200', desc: 'Work is actively being done' },
              { status: 'Active', color: 'bg-green-200', desc: 'Running and generating results' },
              { status: 'Paused', color: 'bg-yellow-200', desc: 'Temporarily stopped' },
              { status: 'Completed', color: 'bg-emerald-200', desc: 'Work is finished' },
              { status: 'On Hold', color: 'bg-slate-200', desc: 'Waiting on external dependency' },
              { status: 'At Risk', color: 'bg-red-200', desc: 'Behind schedule or over budget' },
              { status: 'Archived', color: 'bg-gray-100', desc: 'No longer active, kept for reference' },
            ].map(s => (
              <div key={s.status} className="flex items-center gap-2">
                <div className={`h-3 w-3 rounded-full ${s.color}`} />
                <span className="text-xs font-medium text-gray-800 w-24">{s.status}</span>
                <span className="text-xs text-gray-500">{s.desc}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
